module.exports = __webpack_public_path__ + "static/img/szafa_22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_22.jpg
// module id = PSML
// module chunks = 0